import React, { useEffect, useMemo, useRef, useState } from 'react'
import { observer } from '@/hooks/storeHooks'
import { makeAutoObservable } from 'mobx'

/*
 *time 固定倒计时时间 单位 毫秒  和endTime必须传入一个
 *endTime 倒计时结束时间 时间戳  和time必须传入一个
 *step 步长 默认1000ms 单位毫秒
 *needUnit 需要添加单位 xx天xx时xx秒 默认false
 *showTime 1展示秒 2展示分秒 3展示时分秒 4展示天时分秒 默认展示1
 *replenish 是否需要补0 例如 01:03 true为补0 默认true
 *onChange 时间改变时执行 返回值为剩余时间戳 天 时 分 秒  { times, d, h, m, s }
 */
class TimeStore {
    constructor() {
        makeAutoObservable(this)
    }
    origin_time
    count_down = {
        day: '00',
        hour: '00',
        minute: '00',
        seconds: '00'
    }

    setOriginTime = (value) => {
        this.origin_time = value
    }
    // 修改信息
    changeCountDown = (key, e) => {
        this.count_down[key] = e
    }
}
const TimeDown = ({
    time,
    endTime = 0,
    startTime = Date.now(),
    step = 1000,
    onChange,
    children,
    needUnit = false,
    showTime = 1,
    replenish = true,
    重新获取倒计时,
    ...props
}) => {
    const [store] = useState(() => new TimeStore())

    const { day, hour, minute, seconds } = useMemo(() => {
        return {
            day: CheckTime(Math.floor(store.origin_time / 1000 / 60 / 60 / 24)),
            hour: CheckTime(Math.floor((store.origin_time / 1000 / 60 / 60) % 24)),
            minute: CheckTime(Math.floor((store.origin_time / 1000 / 60) % 60)),
            seconds: CheckTime(Math.floor((store.origin_time / 1000) % 60))
        }
    }, [store.origin_time])

    // useEffect(() => {
    //     if (!time && time != 0) return 
    //     if (!store.origin_time) {
    //         store.origin_time = time
    //     }

    //     const id = setInterval(() => {
    //         let ti = store.origin_time - step
    //         if (ti <= 0) {
    //             ti = 0
    //         }
    //         if (ti == 0) {
    //             onChange && onChange({ times: 0 })
    //             clearInterval(id)
    //         }
    //         store.setOriginTime(ti)
    //     }, step)
    //     return () => clearInterval(id)
    // }, [onChange])

    useEffect(() => {
        if (!time && time != 0) return 
        // origin_time没有值  && origin_time不是倒计时结束的时候
        if (!store.origin_time && store.origin_time !== 0) {
            store.origin_time = time
            // 默认触发倒计时的第一次回调
            onChange({ times: time })
        }

        const worker = new Worker(URL.createObjectURL(new Blob([`
          let timeLeft = ${store.origin_time};
          function countdown() {
            // console.log(timeLeft)
            if (timeLeft > 0) {
              setTimeout(()=>{
                postMessage(timeLeft-${step});
              }, ${step});
            }
          }
          
          countdown();
        `], { type: 'text/javascript' })));
    
        worker.onmessage = function(event) {
            // console.log(event.data)
            if(event.data > 0) {
                store.setOriginTime(event.data);
                onChange && onChange({ times: event.data })
            }else {
                store.setOriginTime(0);
                onChange && onChange({ times: 0 })
                // 终止 worker 执行
                worker.terminate();
            }
            
        };
    
        return () => {
          // store.origin_time 更新的时候会停止 worker
          worker.terminate();
        };
    }, [store.origin_time]);

    useEffect(()=>{
        const handleVisibilityChange = ()=>{
            if (document.hidden) {
                console.log('页面离开');
            } else {
                console.log('页面打开');
                重新获取倒计时 && 重新获取倒计时()
            }
        }
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            document.removeEventListener('visibilitychange', ()=>{});
        }
    },[])

    useEffect(()=>{
        store.setOriginTime(time)
    },[time])

    function CheckTime(i) {
        // console.log(i, i && i.toString().padStart(2, '0') || '00')
        return i && i.toString().padStart(2, '0') || '00'
    }

    return (
        <>
            {children ? (
                children
            ) : (
                <div {...props}>
                    {needUnit
                        ? showTime == 4
                            ? `${day}天:${hour}时:${minute}分:${seconds}秒`
                            : showTime == 3
                            ? `${hour}时:${minute}分:${seconds}秒`
                            : showTime == 2
                            ? `${minute}分:${seconds}秒`
                            : showTime == 1
                            ? `${seconds}秒`
                            : ''
                        : showTime == 4
                        ? `${day}:${hour}:${minute}:${seconds}`
                        : showTime == 3
                        ? `${hour}:${minute}:${seconds}`
                        : showTime == 2
                        ? `${minute}:${seconds}`
                        : showTime == 1
                        ? `${seconds}`
                        : ''}
                </div>
            )}
        </>
    )
}
export default observer(TimeDown)
